// extracted by mini-css-extract-plugin
export default {"button":"lCPh1","danger-normal":"grqUH"};